import { observer } from 'mobx-react'
import React from 'react'

import { ExtendedColumnKey } from '@new/__global/components/FiltersFramework'
import {
  ExtendedColumnCell,
  ExtendedHeaderGroupCell,
} from '@new/domains/fastBookingsTapeChart/__commonStyles'
import { arrivalModeColumnStore } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/components/ArrivalModeColumns/ArrivalModeColumnStore'
import { CaseTabs } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/components/ArrivalsChecklistSidePanel/ArrivalsChecklist.types'
import { ExtendedColumnGroups } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/ExtendedColumns.types'
import { HomeExtendedInfo } from '@new/domains/fastBookingsTapeChart/stores/FastBookingsTapeChartStore'

import { CheckListStatus } from './CheckListStatus'

const columnWidth = 50

export const CleanStatusHeader = () => {
  return (
    <ExtendedHeaderGroupCell
      key={`col-header-${ExtendedColumnKey.cleanStatus}`}
      width={columnWidth}
    >
      Clean
    </ExtendedHeaderGroupCell>
  )
}

const CleanStatusCell = observer(({ home }: { home?: HomeExtendedInfo }) => {
  if (!home?.id) return <ExtendedColumnCell width={columnWidth}>-</ExtendedColumnCell>

  const cleanCases = arrivalModeColumnStore.homeStatuses.get(home.id)?.cleanDetails
  const checklistStatus = cleanCases?.status
  const hasCases = (cleanCases?.total ?? 0) > 0

  return (
    <CheckListStatus
      caseTab={CaseTabs.cleans}
      checklistStatus={checklistStatus}
      columnWidth={columnWidth}
      hasCases={hasCases}
      home={home}
    />
  )
})

export const CleanStatus = {
  header: <CleanStatusHeader />,
  columnKey: ExtendedColumnKey.cleanStatus,
  groupId: ExtendedColumnGroups.arrivalsChecklist,
  width: columnWidth,
  renderer: (home?: HomeExtendedInfo) => (
    <CleanStatusCell key={`col-${ExtendedColumnKey.cleanStatus}-${home?.id}`} home={home} />
  ),
}
